import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Para ti si tienes tu entrevista programada y sientes que el tiempo se acaba', 'Para ti si entiendes español mejor que inglés y los materiales en inglés te confunden', 'Para ti si ya estudiaste antes pero todavía sientes inseguridad al responder en voz alta', 'Para ti si quieres llegar el día de tu entrevista sintiéndote preparado y seguro'];
  const notForYou = ['No es para ti si buscas una solución mágica sin practicar nada', 'No es para ti si ya tienes fluidez total en inglés y el conocimiento actualizado (2026)', 'No es para ti si no tienes entrevista próxima y no tienes urgencia real'];
  return <section className="w-full bg-[#F7F5F0]" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-16">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-17">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500" data-id="element-18">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-8" data-id="element-19">
              Para Quién Es Esto
            </h2>
            <ul className="space-y-6" data-id="element-20">
              {forYou.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-21">
                  <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-gray-700 text-lg" data-id="element-23">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-red-500" data-id="element-24">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1B2A4A] mb-8" data-id="element-25">
              Para Quién NO Es Esto
            </h2>
            <ul className="space-y-6" data-id="element-26">
              {notForYou.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-27">
                  <XCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" data-id="element-28" />
                  <span className="text-gray-700 text-lg" data-id="element-29">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}